/**
 * sophior-jdgm-a11y.js
 * A11y-shim voor het Judge.me reviewwidget (extern, niet in themacode te fixen):
 * de widget-tabs zetten aria-controls="jdgm-tabpanel_..." terwijl dat tabpanel
 * (nog) niet in de DOM staat. axe/Lighthouse keurt dat af als
 * aria-valid-attr-value op elke PDP. Deze shim parkeert een dangling
 * aria-controls in data-sophior-controls en zet hem terug zodra het panel
 * daadwerkelijk bestaat. Gedrag van het widget verandert niet.
 */
(function () {
  'use strict';
  if (window.__sophiorJdgmA11y) return;
  window.__sophiorJdgmA11y = true;

  function syncTabs() {
    var tabs = document.querySelectorAll('.jdgm-tab[aria-controls], .jdgm-tab[data-sophior-controls]');
    for (var i = 0; i < tabs.length; i++) {
      var tab = tabs[i];
      var id = tab.getAttribute('aria-controls') || tab.getAttribute('data-sophior-controls');
      if (!id) continue;
      if (document.getElementById(id)) {
        if (!tab.hasAttribute('aria-controls')) tab.setAttribute('aria-controls', id);
      } else if (tab.hasAttribute('aria-controls')) {
        tab.setAttribute('data-sophior-controls', id);
        tab.removeAttribute('aria-controls');
      }
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      syncTabs();
    });
  }

  function start() {
    syncTabs();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributeFilter: ['aria-controls'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
